import { QueryClient } from '@tanstack/react-query';

// Default staleTime of 60s: data is served from cache instantly on every
// mount, and only refetched in the background once it's older than this —
// most screens don't need every render to be a network round trip.
// refetchOnWindowFocus is what actually delivers "compare with server":
// tabbing back to the app silently re-checks and updates if the server's
// copy changed, with no blocking spinner.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: true,
            retry: 1, // RetryHandler already retries at the transport layer beneath axios
        },
    },
});
